<template>
  <v-card class="hide-overflow" v-if="product">
    <v-toolbar color="transparent" flat>
      <v-btn
        color="grey lighten-2"
        icon
        @click="close()"
        v-if="!isCDS && pageProfile.type != 'chillpainai'"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn
        color="grey lighten-2"
        icon
        @click="close()"
        v-if="(isCDS || pageProfile.type == 'chillpainai') && product.showBack"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>

      <v-btn
        round
        color="grey lighten-2"
        depressed
        v-if="!isCDS && pageProfile.type != 'chillpainai'"
        @click="openCheckout"
      >
        <v-badge color="red">
          <template v-slot:badge v-if="totalItem > 0">
            <span>{{ totalItem }}</span>
          </template>
          <v-icon small class="mr-2">mdi-cart-outline</v-icon>
          <span>{{ $t('Checkout') }}</span>
        </v-badge>
      </v-btn>
    </v-toolbar>

    <v-container>
      <div class="container_producttocart" v-if="showAddToCart">
        <div class="producttocart">
          <v-img
            v-if="productImages && productImages.length > 0"
            :src="productImages[0]"
            :lazy-src="productImages[0]"
            aspect-ratio="1"
            class="grey lighten-2"
            style="max-width: 300px; margin: auto"
          >
          </v-img>
        </div>
      </div>
      <v-layout wrap>
        <v-flex xs12 sm5 offset-sm0>
          <template v-if="currentPhoto">
            <v-img
              :src="currentPhoto"
              :lazy-src="currentPhoto"
              aspect-ratio="1"
              class="grey lighten-2"
              style="max-width: 300px; margin: auto"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </template>
          <hooper v-show="!currentPhoto">
            <slide
              v-for="(image, img_index) in productImages"
              :key="'image_' + img_index"
              style="text-align: center"
            >
              <div
                style="
                  position: relative;
                  width: 100%;
                  height: 100%;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: contain;
                "
                :style="{ 'background-image': `url('${image}')` }"
                @click="
                  currentPreview = image
                  showPreview = true
                "
              >
                <!-- <img :src="image" style="width: 100%; margin: auto" /> -->
                <div
                  style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -28px;
                    margin-top: -28px;
                  "
                >
                  <v-btn
                    class="ma-0"
                    depressed
                    fab
                    dark
                    color="rgb(0, 0, 0, 0.2)"
                  >
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </slide>

            <pagination
              slot="hooper-addons"
              mode="fraction"
              style="background: #00000057; border-radius: 50px; color: white"
            ></pagination>

            <navigation slot="hooper-addons"></navigation>
          </hooper>

          <v-dialog scrollable v-model="showPreview" max-width="690">
            <v-card v-if="currentPreview">
              <v-card-actions class="text-xs-right">
                <v-layout>
                  <v-flex>
                    <v-btn flat fab icon small @click="showPreview = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
              <v-card-text class="pa-0 text-xs-center">
                <v-zoom
                  :img="currentPreview"
                  :width="'100%'"
                  style="margin: auto"
                ></v-zoom>
              </v-card-text>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-dialog>
          <div class="mb-4 hidden-sm-and-up"></div>
        </v-flex>
        <v-flex xs12 sm6 offset-sm1 class="hidden-sm-and-up">
          <div class="title mb-1">{{ product.name }}</div>

          <div class>
            <template v-if="productstock && productstock.length > 0">
              <h3 class="headline price" :style="{ color: theme.color }">
                <template
                  v-if="
                    option != null &&
                    option[3] !=
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                  "
                >
                  {{ currencySign
                  }}{{
                    calculateBundlePrice(
                      option[3],
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    ) | decimalFormat
                  }}
                </template>
                <template v-else-if="option != null && option[3] > option[4]"
                  >{{ currencySign }}{{ option[4] | decimalFormat }}</template
                >
                <template v-else-if="option != null"
                  >{{ currencySign }}{{ option[3] | decimalFormat }}</template
                >
              </h3>
              <div
                class="discount"
                v-if="
                  option != null &&
                  (option[3] > option[4] ||
                    option[3] !=
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      ))
                "
              >
                {{ currencySign }}{{ option[3] | decimalFormat }}
              </div>
              <div v-else>&nbsp;</div>
            </template>
            <template v-else>
              <h3 class="headline price" :style="{ color: theme.color }">
                <template
                  v-if="
                    product.price !=
                    calculateBundlePrice(
                      product.price,
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    )
                  "
                >
                  {{ currencySign
                  }}{{
                    calculateBundlePrice(
                      product.price,
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    ) | decimalFormat
                  }}
                </template>
                <template v-else-if="product.price > product.discountprice"
                  >{{ currencySign
                  }}{{ product.discountprice | decimalFormat }}</template
                >
                <template v-else
                  >{{ currencySign
                  }}{{ product.price | decimalFormat }}</template
                >
              </h3>
              <div
                class="discount"
                v-if="
                  product.price > product.discountprice ||
                  product.price !=
                    calculateBundlePrice(
                      product.price,
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    )
                "
              >
                {{ currencySign }}{{ product.price | decimalFormat }}
              </div>
              <div v-else>&nbsp;</div>
            </template>
          </div>
        </v-flex>

        <v-flex xs12 sm6 offset-sm1>
          <div class="hidden-xs-only">
            <div class="title mb-1">{{ product.name }}</div>

            <div class="mb-4">
              <template v-if="productstock && productstock.length > 0">
                <h3 class="headline price" :style="{ color: theme.color }">
                  <template
                    v-if="
                      option != null &&
                      option[3] !=
                        calculateBundlePrice(
                          option[3],
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        )
                    "
                  >
                    {{ currencySign
                    }}{{
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      ) | decimalFormat
                    }}
                  </template>

                  <template v-else-if="option != null && option[3] > option[4]"
                    >{{ currencySign }}{{ option[4] | decimalFormat }}</template
                  >
                  <template v-else-if="option != null"
                    >{{ currencySign }}{{ option[3] | decimalFormat }}</template
                  >
                </h3>
                <div
                  class="discount"
                  v-if="
                    option != null &&
                    (option[3] > option[4] ||
                      option[3] !=
                        calculateBundlePrice(
                          option[3],
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        ))
                  "
                >
                  {{ currencySign }}{{ option[3] | decimalFormat }}
                </div>
                <div v-else>&nbsp;</div>
              </template>
              <template v-else>
                <h3 class="headline price" :style="{ color: theme.color }">
                  <template
                    v-if="
                      product.price !=
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                    "
                  >
                    {{ currencySign
                    }}{{
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      ) | decimalFormat
                    }}
                  </template>
                  <template v-else-if="product.price > product.discountprice"
                    >{{ currencySign
                    }}{{ product.discountprice | decimalFormat }}</template
                  >
                  <template v-else
                    >{{ currencySign
                    }}{{ product.price | decimalFormat }}</template
                  >
                </h3>
                <div
                  class="discount"
                  v-if="
                    product.price > product.discountprice ||
                    product.price !=
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                  "
                >
                  {{ currencySign }}{{ product.price | decimalFormat }}
                </div>
                <div v-else>&nbsp;</div>
              </template>
            </div>
          </div>

          <div v-if="productstock" class="mb-4 mt-2">
            <div
              v-if="
                !isKhaiwhan ||
                (isKhaiwhan && productstock && productstock.length > 1)
              "
            >
              <v-item-group multiple flat>
                <template
                  v-if="
                    productstockcategories && productstockcategories.length > 1
                  "
                >
                  <product-option
                    v-if="!loadingProduct"
                    v-model="currentOption"
                    :stock="productstock"
                    :category="productstockcategories"
                    @changeOption="onChangeOption"
                    @focusOption="focusOption"
                    @blurOption="onViewStockPhoto(null)"
                  ></product-option>
                </template>
                <template v-else>
                  <template
                    v-if="pageProfile && pageProfile.type == 'constructpage'"
                  >
                    <v-radio-group
                      id="construct_productoption"
                      v-model="option"
                      @change="onChangeOptionList"
                    >
                      <v-radio
                        v-for="(stype, sindex) in productstock"
                        :key="'stock_' + sindex"
                        :label="stype[1]"
                        :value="stype"
                        :color="theme.color"
                        :disabled="parseInt(stype[2]) < 1"
                      >
                        <template v-slot:label style="width: 100%">
                          <v-layout>
                            <v-flex class="px-2">
                              {{ stype[1] }}
                            </v-flex>
                            <v-flex
                              class="text-xs-right"
                              :style="{ color: theme.color }"
                            >
                              {{ stype[4] }} บาท
                            </v-flex>
                          </v-layout>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </template>
                  <template v-else>
                    <template v-for="(stype, sindex) in productstock">
                      <v-chip
                        :key="'stock_' + sindex"
                        depressed
                        @focus="
                          onViewStockPhoto(stype[7])
                          option = stype
                          quantity = 1
                        "
                        @blur="onViewStockPhoto(null)"
                        :disabled="parseInt(stype[2]) < 1"
                        @click="onChangeOption(stype[1])"
                        :dark="option && stype[0] == option[0]"
                        :color="
                          option && stype[0] == option[0] ? theme.color : ''
                        "
                      >
                        <v-avatar v-if="stype[7]">
                          <img :src="stype[7]" :alt="stype[1]" />
                        </v-avatar>
                        {{ stype[1] }}
                      </v-chip>
                    </template>
                  </template>
                </template>
              </v-item-group>
            </div>
            <div v-if="isKhaiwhan">
              <v-text-field
                v-model="optionkhaiwhan"
                :color="theme.color"
                outline
                placeholder="เช่น ไม่ใส่ไข่กุ้ง"
                label="รายละเอียดเพิ่มเติม"
              ></v-text-field>
            </div>
          </div>

          <template
            v-if="
              pageProfile &&
              pageProfile.type != 'ros' &&
              pageProfile.type != 'constructpage'
            "
          >
            <v-layout
              wrap
              v-if="
                (productstockcategories &&
                  productstockcategories.length == 0) ||
                currentOption
              "
            >
              <v-flex xs4>{{ $t('Quantity') }}</v-flex>
              <v-flex xs8 class="text-xs-right">
                <template v-if="option && option[2] > 0">
                  <v-btn
                    outline
                    fab
                    :color="theme.color"
                    @click="removeCount()"
                    :disabled="quantity == 1"
                    small
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                  <span
                    style="
                      width: 30px;
                      display: inline-block;
                      margin-left: 5px;
                      margin-right: 5px;
                      text-align: center;
                    "
                    >{{ quantity }}</span
                  >

                  <v-btn
                    outline
                    fab
                    :color="theme.color"
                    @click="addCount()"
                    :disabled="
                      quantity == option[2] ||
                      ((isCDS || pageProfile.type == 'chillpainai') &&
                        quantity >= 10) ||
                      ((isCDS || pageProfile.type == 'chillpainai') &&
                        category.name == 'Limit Order 1 Piece')
                    "
                    small
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <div v-else class="red--text">{{ $t('Sold Out') }}</div>
              </v-flex>
              <v-flex
                v-if="option && option.length > 0"
                xs12
                class="text-xs-right caption mt-2"
              >
                <span class="small" v-if="parseInt(option[2]) == 1"
                  >({{
                    $t('Only {item} item left', { item: option[2] })
                  }})</span
                >
                <span
                  class="small"
                  v-else-if="parseInt(option[2]) > 0 && option[2] < 5"
                  >({{
                    $t('Only {item} items left', { item: option[2] })
                  }})</span
                >
              </v-flex>
            </v-layout>
          </template>

          <template v-if="pageProfile.pageid != '485851741439218'">
            <div
              class="caption"
              v-if="option && option[8] !== null && option[8] > 0"
            >
              <!-- ย่งยู่กี่ไม่แสดง -->
              {{
                $t('Weight {weight} kilogram per piece', {
                  weight: option[8] / 1000
                })
              }}
            </div>
            <div class="caption" v-else-if="product.weight != 0">
              {{
                $t('Weight {weight} kilogram per piece', {
                  weight: product.weight / 1000
                })
              }}
            </div>
          </template>
        </v-flex>
      </v-layout>
      <template v-if="isBearhouse && hasBubbleTea">
        <h3 class="headline name mb-2" :style="{ color: theme.color }">
          เพิ่มท็อปปิ้ง
        </h3>
        <template v-for="(bubble, bindex) in bubbletea">
          <v-card :key="bubble.id" class="mb-2">
            <v-card-text>
              <v-layout>
                <v-flex shrink>
                  <img :src="bubble.photourl" style="max-width: 80px" />
                </v-flex>
                <v-flex class="pl-3">
                  {{ bubble.name }}
                  <div :style="{ color: theme.color }">
                    {{ currencySign }}
                    <template
                      v-if="
                        bubble.productstock && bubble.productstock.length > 0
                      "
                    >
                      {{ bubble.productstock[0][4] | decimalFormat }}
                      <template
                        v-if="bubble.productstock[0][4] * bubble.quantity > 0"
                        >({{
                          (bubble.discountprice * bubble.quantity)
                            | decimalFormat
                        }})</template
                      >
                    </template>
                    <template v-else>
                      {{ bubble.discountprice | decimalFormat }}
                      <template
                        v-if="bubble.discountprice * bubble.quantity > 0"
                        >({{
                          (bubble.discountprice * bubble.quantity)
                            | decimalFormat
                        }})</template
                      >
                    </template>
                  </div>
                  <div class="text-xs-right">
                    <template
                      v-if="
                        bubble.productstock && bubble.productstock.length > 0
                      "
                    >
                      <v-btn
                        outline
                        fab
                        :color="theme.color"
                        @click="removeBubbleCount(bindex)"
                        :disabled="bubble.quantity == 0"
                        small
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      <span
                        style="
                          width: 30px;
                          display: inline-block;
                          margin-left: 5px;
                          margin-right: 5px;
                          text-align: center;
                        "
                        >{{ bubble.quantity }}</span
                      >

                      <v-btn
                        outline
                        fab
                        :color="theme.color"
                        @click="addBubbleCount(bindex)"
                        :disabled="bubble.quantity == bubble.productstock[0][2]"
                        small
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
      </template>

      <template
        v-if="$store.state.allowProductRemark.includes(pageProfile.pageid)"
      >
        <v-text-field
          v-model="cart_remark"
          :color="theme.color"
          outline
          maxlength="50"
          counter="50"
          :data-vv-as="$t('Remark')"
          :name="'remark'"
          :label="$t('Remark')"
          :error="errors.has('remark') ? true : false"
          :error-messages="errors.has('remark') ? errors.first('remark') : ''"
        ></v-text-field>
      </template>

      <template v-if="isGaiGao">
        <template v-for="index in remarkcount">
          <v-text-field
            :key="index"
            v-model="optionGaiGao[index - 1]"
            :color="theme.color"
            outline
            v-validate="'required'"
            :data-vv-as="`รายละเอียดเพิ่มเติม ${index}`"
            :name="`remark${index}`"
            placeholder="เช่น ออริจินอล"
            :label="`รายละเอียดเพิ่มเติม ${index}`"
            :error="errors.has(`remark${index}`) ? true : false"
            :error-messages="
              errors.has(`remark${index}`) ? errors.first(`remark${index}`) : ''
            "
          ></v-text-field>
        </template>
      </template>

      <template v-if="isGaiGao && hasTopup">
        <h3 class="headline name mb-2" :style="{ color: theme.color }">
          เครื่องเคียง
        </h3>
        <template v-for="(topup, bindex) in topups">
          <v-card :key="topup.id" class="mb-2">
            <v-card-text>
              <v-layout>
                <v-flex shrink>
                  <img :src="topup.photourl" style="max-width: 80px" />
                </v-flex>
                <v-flex class="pl-3">
                  {{ topup.name }}
                  <div :style="{ color: theme.color }">
                    {{ currencySign }}
                    <template
                      v-if="topup.productstock && topup.productstock.length > 0"
                    >
                      {{ topup.productstock[0][4] | decimalFormat }}
                      <template
                        v-if="topup.productstock[0][4] * topup.quantity > 0"
                        >({{
                          (topup.discountprice * topup.quantity)
                            | decimalFormat
                        }})</template
                      >
                    </template>
                    <template v-else>
                      {{ topup.discountprice | decimalFormat }}
                      <template v-if="topup.discountprice * topup.quantity > 0"
                        >({{
                          (topup.discountprice * topup.quantity)
                            | decimalFormat
                        }})</template
                      >
                    </template>
                  </div>
                  <div class="text-xs-right">
                    <template
                      v-if="topup.productstock && topup.productstock.length > 0"
                    >
                      <v-btn
                        outline
                        fab
                        :color="theme.color"
                        @click="removeTopupCount(bindex)"
                        :disabled="topup.quantity == 0"
                        small
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      <span
                        style="
                          width: 30px;
                          display: inline-block;
                          margin-left: 5px;
                          margin-right: 5px;
                          text-align: center;
                        "
                        >{{ topup.quantity }}</span
                      >

                      <v-btn
                        outline
                        fab
                        :color="theme.color"
                        @click="addTopupCount(bindex)"
                        :disabled="topup.quantity == topup.productstock[0][2]"
                        small
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
        <div class="mb-5"></div>
      </template>

      <template v-if="isGaiGao && hasAddon">
        <h3 class="headline name mb-2" :style="{ color: theme.color }">
          เมนูที่แลกซื้อเครื่องเคียงได้ 10 บาท (ได้ 1 สิทธิ์/set)
          <v-btn
            :color="theme.color"
            small
            dark
            v-if="gaigaoaddon"
            @click="
              gaigaoaddon = null
              updateTopupPrice()
            "
          >
            <v-icon small class="mr-1">close</v-icon>Clear
          </v-btn>
        </h3>
        <v-radio-group
          v-model="gaigaoaddon"
          class="full-width"
          style="width: 100%"
        >
          <template v-for="addon in addonproducts">
            <v-card :key="addon.id" class="mb-2">
              <v-card-text>
                <v-layout>
                  <v-radio
                    :value="addon"
                    :color="theme.color"
                    :disabled="addon.quantity == 0"
                    @click="changeAddon(addon)"
                  ></v-radio>
                  <v-flex shrink>
                    <img :src="addon.photourl" style="max-width: 80px" />
                  </v-flex>
                  <v-flex class="pl-3">
                    {{ addon.name }}
                    <div :style="{ color: theme.color }">
                      {{ currencySign }}
                      <template
                        v-if="
                          addon.productstock && addon.productstock.length > 0
                        "
                        >{{
                          addon.productstock[0][4] | decimalFormat
                        }}</template
                      >
                      <template v-else>{{
                        addon.discountprice | decimalFormat
                      }}</template>
                    </div>
                    <div class="text-xs-right">
                      <template
                        v-if="
                          addon.productstock && addon.productstock.length > 0
                        "
                      ></template>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </template>
        </v-radio-group>
      </template>

      <v-layout wrap>
        <v-flex xs12>
          <v-divider class="mt-4 mb-4"></v-divider>
        </v-flex>
        <v-flex xs12 class="mb-5">
          <div class="body-1">
            <h3 class="headline name mb-2" :style="{ color: theme.color }">
              {{ $t('Product Detail') }}
            </h3>
            <template v-if="product.description">
              <nl2br
                tag="div"
                :text="product.description"
                class="description"
              ></nl2br>
            </template>
          </div>
        </v-flex>
      </v-layout>

      <div
        :style="{
          height:
            pageProfile && pageProfile.type == 'constructpage'
              ? '135px'
              : '95px'
        }"
      ></div>
      <v-card
        style="position: fixed; z-index: 3; bottom: 0; left: 0; right: 0"
        v-if="pageProfile && pageProfile.type != 'ros'"
      >
        <v-layout wrap>
          <!-- Construction Page Customize -->
          <template
            v-if="
              pageProfile &&
              pageProfile.type == 'constructpage' &&
              ((productstockcategories && productstockcategories.length == 0) ||
                currentOption)
            "
          >
            <v-flex xs4 class="px-3 py-2">{{ $t('Quantity') }}</v-flex>
            <v-flex xs8 class="text-xs-right">
              <template v-if="option && option[2] > 0">
                <v-btn
                  outline
                  fab
                  :color="theme.color"
                  @click="removeCount()"
                  :disabled="quantity == 1"
                  style="height: 30px; width: 30px"
                  small
                >
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>
                <span
                  style="
                    width: 30px;
                    display: inline-block;
                    margin-left: 5px;
                    margin-right: 5px;
                    text-align: center;
                  "
                  >{{ quantity }}</span
                >

                <v-btn
                  outline
                  fab
                  :color="theme.color"
                  @click="addCount()"
                  style="height: 30px; width: 30px"
                  :disabled="
                    quantity == option[2] ||
                    ((isCDS || pageProfile.type == 'chillpainai') &&
                      quantity >= 10) ||
                    ((isCDS || pageProfile.type == 'chillpainai') &&
                      category.name == 'Limit Order 1 Piece')
                  "
                  small
                >
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
              <div v-else class="red--text">{{ $t('Sold Out') }}</div>
            </v-flex>
            <v-flex
              v-if="option && option.length > 0 && option[2] < 5"
              xs12
              class="text-xs-right caption mt-2 caption"
            >
              <template v-if="parseInt(option[2]) == 1"
                >({{
                  $t('Only {item} item left', { item: option[2] })
                }})</template
              >
              <template v-else-if="parseInt(option[2]) > 0 && option[2] < 5"
                >({{
                  $t('Only {item} items left', { item: option[2] })
                }})</template
              >
            </v-flex>
          </template>
          <v-flex xs4 class="px-3 py-2">{{ $t('Total') }}</v-flex>
          <v-flex xs8 class="text-xs-right px-3 py-2">
            <template v-if="productstock.length > 0">
              <template
                v-if="
                  option != null &&
                  option[3] !=
                    calculateBundlePrice(
                      option[3],
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    )
                "
              >
                <span
                  class="discount mr-1"
                  v-if="
                    option != null &&
                    option[3] !=
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                  "
                  >{{ currencySign
                  }}{{
                    (option[3] * quantity + additional_price) | decimalFormat
                  }}</span
                >
                <template v-if="option != null">
                  {{ currencySign
                  }}{{
                    (calculateBundlePrice(
                      option[3],
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    ) *
                      quantity +
                      additional_price)
                      | decimalFormat
                  }}
                </template>
              </template>
              <template v-else-if="option != null && option[3] > option[4]">
                <span class="discount mr-1"
                  >{{ currencySign
                  }}{{
                    (option[3] * quantity + additional_price) | decimalFormat
                  }}</span
                >
                {{ currencySign
                }}{{
                  (option[4] * quantity + additional_price) | decimalFormat
                }}
              </template>
              <template v-else>
                <template v-if="option != null"
                  >{{ currencySign
                  }}{{
                    (option[3] * quantity + additional_price) | decimalFormat
                  }}</template
                >
              </template>
            </template>
            <template v-else>
              {{ currencySign }}
              <template v-if="product.price > product.discountprice">{{
                (product.discountprice * quantity + additional_price)
                  | decimalFormat
              }}</template>
              <template v-else>
                {{
                  (product.price * quantity + additional_price) | decimalFormat
                }}
              </template>
            </template>
          </v-flex>
          <v-flex xs12>
            <v-divider />
            <template
              v-if="
                [
                  '740558886346101',
                  '104974550989962',
                  '105927064511045'
                ].includes(pageProfile.pageid) ||
                ['constructpage'].includes(pageProfile.type)
              "
            >
              <!-- !['485851741439218'].includes(pageProfile.pageid) && pageProfile.type != 'rabbit' -->
              <v-layout wrap>
                <v-flex xs5>
                  <v-btn
                    depressed
                    flat
                    dark
                    large
                    :loading="loading || loadingCart || loadingProduct"
                    :color="theme.color"
                    v-if="!isOutOfStock"
                    @click="addToCart('addtocart')"
                    :class="{ disabled: isOutOfStock }"
                    :disabled="isOutOfStock || !option"
                    style="width: 100%; border-radius: 0; height: 55px"
                    class="ma-0"
                    :style="{
                      'padding-bottom': $store.getters.getIosPadding
                        ? '15px'
                        : '0'
                    }"
                  >
                    <v-icon>mdi-cart-plus</v-icon>&nbsp;
                    <span>{{ $t('Add to cart') }}</span>
                  </v-btn>
                </v-flex>
                <v-flex xs7>
                  <v-btn
                    depressed
                    dark
                    large
                    :loading="loading || loadingCart || loadingProduct"
                    :color="theme.color"
                    v-if="!isOutOfStock"
                    @click="addToCart('addandclose')"
                    :class="{ disabled: isOutOfStock }"
                    :disabled="isOutOfStock || !option"
                    style="width: 100%; border-radius: 0; height: 55px"
                    class="ma-0"
                    :style="{
                      'padding-bottom': $store.getters.getIosPadding
                        ? '15px'
                        : '0'
                    }"
                  >
                    <v-icon>mdi-cart-outline</v-icon>&nbsp;

                    <span>{{ $t('Buy') }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <v-btn
                depressed
                dark
                large
                :loading="loading || loadingCart || loadingProduct"
                :color="theme.color"
                v-if="!isOutOfStock"
                @click="addToCart('addandclose')"
                :class="{ disabled: isOutOfStock }"
                :disabled="isOutOfStock || !option"
                style="width: 100%; border-radius: 0; height: 55px"
                class="ma-0"
                :style="{
                  'padding-bottom': $store.getters.getIosPadding ? '15px' : '0'
                }"
              >
                <v-icon>mdi-cart-plus</v-icon>&nbsp;
                <span v-if="pageProfile.type == 'rabbit'">{{
                  $t('Add to cart Rabbit')
                }}</span>
                <span v-else>{{ $t('Add to cart') }}</span>
              </v-btn>
            </template>
          </v-flex>
        </v-layout>

        <v-snackbar
          v-model="snackbar"
          :top="true"
          :color="'success'"
          :timeout="4000"
        >
          {{ $t('Add to cart') }}
          <v-btn dark flat @click="snackbar = false"> Close </v-btn>
        </v-snackbar>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import { Hooper, Slide, Pagination, Navigation } from 'hooper'
import 'hooper/dist/hooper.css'

import { mapGetters } from 'vuex'
import config from '@/config'
import axios from 'axios'
import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import Modal from '@/components/Modal.vue'
import ModalImage from '@/components/ModalImage.vue'
import numeral from 'numeral'
import ProductOption from './ProductOption'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import Nl2br from 'vue-nl2br'

import vZoom from 'vue-zoom'
import {
  bearhousepackagehasbubble,
  bearhousebubbletea
} from '@/assets/js/BearHouse.js'

export default {
  props: ['value', 'products', 'loadingCart', 'categories'],
  data() {
    return {
      showAddToCart: false,
      snackbar: false,
      currentOption: null,
      product: this.value,
      showAlert: false,
      showPreview: false,
      optionkhaiwhan: '',
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: true,
      loading: false,
      productbundle: [],

      isImageFail: false,
      bubbletea: [],
      additional_price: 0,
      currentPhoto: null,
      gaigaoaddon: null,
      hasAddon: false,
      hasTopup: false,
      topups: [],
      remarkcount: 0,
      optionGaiGao: [],
      cart_remark: ''
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      theme: 'getTheme',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile'
    }),
    filterCategory() {
      if (!this.categories) {
        return []
      }
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        var categories = this.categories
          .filter((el) => {
            return el.name.includes(this.shop)
          })
          .map((el) => {
            var cat = { ...el }
            cat.name = cat.name.replace(this.shop + '/', '')
            return cat
          })
        return categories
      } else {
        return this.categories
      }
    },
    filterCart() {
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        return this.cart.filter((el) => {
          return (
            this.filterCategory.findIndex((cat) => {
              return cat.id == el.categoryid
            }) != -1
          )
        })
      } else {
        return this.cart
      }
    },
    totalItem() {
      return this.filterCart.length > 0
        ? this.filterCart
            .map((el) => {
              return parseInt(el.quantity)
            })
            .reduce((prev, cur) => {
              return prev + cur
            })
        : 0
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == 'gaigao'
    },
    category() {
      return this.categories.find((el) => el.id == this.product.categoryid)
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    currencySign: function () {
      if (this.product && this.product.currency) {
        return this.getCurrencyByCode(this.product.currency)
      }
      return '฿'
    },
    productImages: function () {
      let images = []
      if (this.product) {
        try {
          images = this.product.photourl.split(';;')
        } catch (error) {
          //
        }
        // this.previewImage =
        //   images.length > 0
        //     ? images[0]
        //     : "../assets/img/ecommerce/product_image_fallback@2x.png";
      }
      return images
    },
    isOutOfStock: function () {
      let vm = this
      if (vm.option) {
        if (parseInt(vm.option[2]) <= 0) {
          return true
        }
        if (parseInt(vm.option[2]) < vm.quantity) {
          return true
        }
        return false
      }
      return true
    },
    priceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.price
        max = this.product.price
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][3]
            max = this.product.productstock[index][3]
          } else {
            if (this.product.productstock[index][3] > max) {
              max = this.product.productstock[index][3]
            }
            if (this.product.productstock[index][3] < min) {
              min = this.product.productstock[index][3]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.discountprice
        max = this.product.discountprice
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][4]
            max = this.product.productstock[index][4]
          } else {
            if (this.product.productstock[index][4] > max) {
              max = this.product.productstock[index][4]
            }
            if (this.product.productstock[index][4] < min) {
              min = this.product.productstock[index][4]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function () {
      var max = 0

      if (this.product.productstock.length <= 0) {
        max =
          ((this.product.price - this.product.discountprice) /
            this.product.price) *
          100
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            max =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
          } else {
            var percent =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
            if (max < percent) {
              max = percent
            }
          }
        }
      }

      return max
    },
    totalBundle: function () {
      var vm = this
      var quantity = 0
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function (product) {
            quantity += product.quantity
          })
        }
        return quantity
      }
      var products = vm.cart.filter(function (product) {
        return product.id == vm.product.id
      })
      quantity = 0
      products.map((p) => {
        quantity += p.quantity
      })
      return quantity
    },
    productstock: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.product.productstock
      // .sort(function(a, b) {
      //   if (a[6] > b[6]) {
      //     return 1;
      //   } else if (a[6] < b[6]) {
      //     return -1;
      //   } else {
      //     return 0;
      //   }
      // });
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.id)
    },
    productstockcategories() {
      try {
        return JSON.parse(this.product.productstockcategories)
      } catch (error) {
        return []
      }
    },
    addonproducts() {
      return this.products.filter((el) => {
        return el.categoryid == 10625
      })
    }
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    // Carousel,
    Slide,
    Hooper,
    Pagination,
    Navigation,
    ProductOption
    // Slide,
  },
  watch: {
    value: function () {
      let vm = this
      this.product = this.value
      //   this.getStock()
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0]
      }

      vm.setOption()
    },
    showModal: function (newVal) {
      if (newVal) {
        this.addClass('body', 'modal-open')
      } else {
        this.removeClass('body', 'modal-open')
      }
    }
  },
  created: function () {},
  mounted: function () {
    // this.getStock()
    let vm = this
    this.cart_remark = ''
    if (this.productImages.length > 0) {
      this.selectedImage = this.productImages[0]
    }

    vm.setOption()

    if (this.isBearhouse) {
      this.bubbletea = bearhousebubbletea(this.products)
      for (let index = 0; index < this.bubbletea.length; index++) {
        this.bubbletea[index].quantity = 0
      }
    }

    this.getProductBundle()

    if (this.isGaiGao) {
      var topupproducts = this.products.filter((el) => {
        return el.categoryid == 10431
      })
      this.topups = JSON.parse(JSON.stringify(topupproducts))
      for (let index = 0; index < this.topups.length; index++) {
        this.$set(this.topups[index], 'quantity', 0)
      }

      this.hasAddon = this.product.description.includes('แลกเครื่องเคียง')
      this.hasTopup = this.product.description.includes('เครื่องเคียงได้')
      var res = this.product.description.match(/เลือกได้ \d+ ซอส/g)
      if (res) {
        var count = res[0].match(/\d+/g)
        this.remarkcount = parseInt(count)
      }
    }

    vm.loadingProduct = false
  },
  methods: {
    openCheckout() {
      this.$emit('openCheckout')
    },
    focusOption(payload) {
      this.onViewStockPhoto(payload[7])
      this.option = payload
      this.quantity = 1
    },
    changeAddon(value) {
      this.gaigaoaddon = value
      this.updateTopupPrice()
    },
    onChangeOptionList(type) {
      var stock = type

      if (stock) {
        this.option = stock
        this.quantity = 1
      } else {
        this.option = null
        this.quantity = 1
      }
    },
    onChangeOption(type) {
      var stock = this.productstock.find((el) => {
        // console.log(el[1]);
        return el[1] == type
      })

      this.onChangeOptionList(stock)
    },
    async onViewStockPhoto(val) {
      await this.$nextTick()
      this.currentPhoto = val
    },
    updateBubblePrice() {
      var price = 0

      if (this.bubbletea && this.bubbletea.length > 0) {
        this.bubbletea.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity
          } else {
            price += el.discountprice * el.quantity
          }
        })
      }
      this.additional_price = price
    },
    updateTopupPrice() {
      var price = 0

      if (this.topups && this.topups.length > 0) {
        this.topups.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity
          } else {
            price += el.discountprice * el.quantity
          }
        })
      }
      if (
        this.gaigaoaddon &&
        this.gaigaoaddon.productstock.length > 0 &&
        this.gaigaoaddon.productstock[0][2] > 0
      ) {
        price += this.gaigaoaddon.productstock[0][4]
      }
      this.additional_price = price
    },
    addBubbleCount(index) {
      this.$set(
        this.bubbletea[index],
        'quantity',
        this.bubbletea[index].quantity + 1
      )
      this.$forceUpdate()
      this.updateBubblePrice()
    },
    removeBubbleCount(index) {
      this.$set(
        this.bubbletea[index],
        'quantity',
        this.bubbletea[index].quantity - 1
      )
      this.$forceUpdate()
      this.updateBubblePrice()
    },
    addTopupCount(index) {
      this.$set(this.topups[index], 'quantity', this.topups[index].quantity + 1)
      this.$forceUpdate()
      this.updateTopupPrice()
    },
    removeTopupCount(index) {
      this.$set(this.topups[index], 'quantity', this.topups[index].quantity - 1)
      this.$forceUpdate()
      this.updateTopupPrice()
    },
    getProductBundle: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let url =
          config.getConfig('serverUrl') +
          'productbundle?productid=' +
          vm.product.id
        axios.get(url).then((response) => {
          response = response.data
          if (response.responsecode == 200) {
            vm.productbundle = response.productbundlelist
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    onPreviewImgError: function () {
      this.isImageFail = true
      //  this.previewImage = "../assets/img/ecommerce/product_image_fallback@2x.png"
    },
    setOption: function () {
      let vm = this
      if (
        vm.product &&
        vm.product.productstock &&
        vm.product.productstock.length > 0
      ) {
        vm.option = null
        try {
          let option = vm.productstock.find(
            (val) => val && parseInt(val[2]) > 0
          )
          if (option) {
            vm.option = option
            vm.currentOption = vm.option[1]
          }
        } catch (error) {
          //
        }
      } else {
        vm.option = null
      }
    },
    close: async function () {
      // let vm = this;

      let isClose = true
      // if (this.$store.state.cds.includes(this.pageProfile.pageid)) {
      //   let result = await this.$swal({
      //     title: "ยืนยันไม่สั่งสินค้านี้",
      //     type: "info",
      //     confirmButtonText: this.$t("Confirm"),
      //     cancelButtonText: this.$t("Cancel"),
      //     showCancelButton: true,
      //     reverseButtons: true,
      //   });

      //   if (result.value) {
      //     isClose = true;
      //   } else {
      //     isClose = false;
      //   }
      // }

      if (isClose) {
        this.closeWindow()
      }
    },
    closeWindow() {
      this.showModal = false
      this.$emit('close')

      if (window.history.length == 0) {
        //
      } else {
        // window.history.back();
      }
    },
    addCount: function () {
      if (!this.option || this.option == null) {
        return false
      }
      if (this.quantity < this.option[2]) {
        this.quantity++
      }
    },
    removeCount: function () {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    async addToCart(addcarttype) {
      let vm = this

      var isClose = ['addandclose', 'addandcheckout'].includes(addcarttype)
      if (vm.pageProfile.type == 'rabbit') {
        isClose = false
      }
      // if (vm.cart.length >= 10) {
      //   vm.showAlert = true;
      //   return false;
      // }
      if (vm.isOutOfStock) {
        return false
      }
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      vm.loading = true

      var price = vm.option[3]
      var discountprice = vm.option[4]
      var option = { ...vm.option }
      if (vm.isKhaiwhan) {
        if (vm.productstock.length > 1 && !vm.optionkhaiwhan) {
          // DO nothing
        } else {
          option[1] = vm.optionkhaiwhan
            ? option[1] + ' - ' + vm.optionkhaiwhan
            : 'Normal'
        }
      }
      if (vm.isCDS) {
        var productincart = vm.cart.find((el) => {
          return el.id == vm.product.id && el.option == option[1]
        })

        if (productincart && productincart.quantity + vm.quantity > 10) {
          await vm.$swal({
            title: vm.$t(
              'คุณสามารถซื้อสินค้าชนิดนี้ได้ไม่เกิน 10 ชิ้นเท่านั้น'
            ),
            type: 'warning',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          vm.loading = false
          return false
        }
      }

      if (vm.isGaiGao) {
        if (vm.productstock.length > 1 && !vm.optionGaiGao) {
          // DO nothing
        } else {
          option[1] =
            vm.optionGaiGao && vm.optionGaiGao.length > 0
              ? option[1] + ' - ' + vm.optionGaiGao.join(',')
              : option[1]
        }
      }
      let item = {
        quantity: vm.quantity,
        option: option,
        buttonaction: vm.product.buttonaction,
        buttonname: vm.product.buttonname,
        buttonurl: vm.product.buttonurl,
        categoryid: vm.product.categoryid,
        currency: vm.product.currency,
        description: vm.product.description,
        id: vm.product.id,
        keyword: vm.product.keyword,
        name: vm.product.name,
        pageid: vm.product.pageid,
        photohash: vm.product.photohash,
        photourl: vm.option[7] ? vm.option[7] : vm.product.photourl,
        price: price,
        priority: vm.product.priority,
        subcategoryid: vm.product.subcategoryid,
        discountprice: discountprice,
        productbundle: vm.productbundle,
        cart_remark: vm.cart_remark,
        weight: vm.product.weight ? vm.product.weight : 0
      }
      if (this.isBearhouse) {
        vm.bubbletea.map((el) => {
          if (el.quantity > 0) {
            vm.addAddonToCart(el)
          }
        })
      }

      if (this.isGaiGao) {
        vm.topups.map((el) => {
          if (el.quantity > 0) {
            vm.addAddonToCart(el)
          }
        })
      }

      if (
        this.isGaiGao &&
        this.gaigaoaddon &&
        this.gaigaoaddon.productstock.length > 0 &&
        this.gaigaoaddon.productstock[0][2] > 0
      ) {
        this.gaigaoaddon.quantity = 1
        vm.addAddonToCart(this.gaigaoaddon)
      }

      vm.setOption()

      vm.$emit('addToCart', {
        item: item,
        loading: function () {
          if (['addtocart'].includes(addcarttype)) {
            //
            vm.showAddToCart = false
            vm.$nextTick().then(() => {
              vm.showAddToCart = true
            })
          }
          if (!vm.isCDS && vm.pageProfile.type != 'chillpainai') {
            if (isClose) {
              if (['addandcheckout'].includes(addcarttype)) {
                vm.$emit('openCheckout')
              } else {
                vm.closeWindow()
              }
            } else {
              vm.snackbar = true
            }
            vm.quantity = 1
          }
          vm.loading = false
        }
      })

      // if (!vm.isCDS) {
      //   if (isClose) {
      //     vm.closeWindow();
      //     if (["addandcheckout"].includes(addcarttype)) {
      //       vm.$emit("openCheckout");
      //     }
      //   } else {
      //     vm.snackbar = true;
      //   }
      //   vm.quantity = 1;
      // }
    },
    addAddonToCart(product) {
      let vm = this

      var price = 0
      var discountprice = 0
      vm.loading = true

      if (product.productstock.length > 0) {
        price = product.productstock[0][3]
        discountprice = product.productstock[0][4]
      } else {
        price = product.price
        discountprice = product.discountprice
      }
      var option =
        product.productstock.length > 0 ? product.productstock[0] : null
      let item = {
        quantity: product.quantity,
        option: option,
        buttonaction: product.buttonaction,
        buttonname: product.buttonname,
        buttonurl: product.buttonurl,
        categoryid: product.categoryid,
        currency: product.currency,
        description: product.description,
        id: product.id,
        keyword: product.keyword,
        name: product.name,
        pageid: product.pageid,
        photohash: product.photohash,
        photourl: product.photourl,
        price: price,
        priority: product.priority,
        subcategoryid: product.subcategoryid,
        discountprice: discountprice,
        productbundle: []
      }
      vm.$emit('addToCart', {
        item: item,
        loading: function () {
          vm.loading = false
        }
      })
    },
    getStock: function () {
      let vm = this
      axios
        .get(
          config.getConfig('serverUrl') +
            'productstock?productid=' +
            vm.product.id
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          response = response.data
          if (response.responsecode == 200) {
            vm.stock = response.productstocklist
            vm.setOption()
          } else {
            // console.log(response);
          }
        })
    }
  }
}
</script>
<style lang="scss">
#construct_productoption {
  label {
    width: 100%;
  }
}
.full-width {
  .v-input__control {
    width: 100% !important;
  }
}

.container_producttocart {
  right: 0;
  position: fixed;
  z-index: 5;
  width: 200px;
  animation: drawArc1 2s linear 1;
}

.producttocart {
  border-radius: 10px;
  overflow: hidden;
  display: inline-block;
  border: 1px solid white;
  width: 50px;
  height: 50px;
  background: grey;
  opacity: 0;
  animation: drawArc2 2s linear 1;
}

@keyframes drawArc1 {
  0% {
    transform: translateY(100px);
  }
  10% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}

@keyframes drawArc2 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
    transform: rotate(360deg);
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(270deg);
  }
}
</style>
